import React, { useState} from 'react';
import Select from 'react-select'

function AppVersionItem(props){
  const ids = {
    app_id: props.app.id,
    version_id: null
  }

  const versionList = props.app.versions.map(version => {
    return {
      value: version.id,
      label: version.versionNumber
    }
  })

  const noSetVersion = {
    value: -1,
    label: 'None'
  }
  
  versionList.unshift(noSetVersion)

  function getStartVersion(){
      let ver = -1
      console.log('setting app: ' + props.app.id)
      // loop through until you find the app
      for(var i = 0; i < props.group.Versions.length;i++){
        if(props.group.Versions[i].appID === props.app.id){
          // set the version of this app that we have on the group
          for(var j = 0; j < versionList.length;j++){
            if(versionList[j].value === props.group.Versions[i].id){
              ver = j
              break
            }
          }
          break
        }
      }

      if(ver > -1){
        console.log('setting version: ' + versionList[ver].value)
        return (versionList[ver])
      } else {
        console.log('setting version: ' + noSetVersion.value)
        return (noSetVersion)
      }
  }

  function setVersionOnGroup(val){
    console.log(val)
    ids.version_id = (val != null) ? val.value : null
    setSelectedVersion(val)
    props.postGroupVersion(ids)
  }

//   const [selectedVersion, setSelectedVersion] = useState(getStartVersion())
  const [selectedVersion, setSelectedVersion] = useState(() => getStartVersion());

  return (
    <div className="grid-item" key={props.app.id} >
      <h3>{props.app.displayName}</h3>
      <p>{props.app.bundle}</p>
      <Select value={selectedVersion} options={versionList} onChange={setVersionOnGroup} />
    </div>
  )
}

export default AppVersionItem;